/*
 * Per-property location data, used by <LocationMap> for the "Where You'll Be"
 * band and by each page's JSON-LD.
 *
 * mapsUrl     - Google Maps "Share -> Copy link". Drives the button and the
 *               hasMap property in the schema. With it empty the whole band is
 *               skipped, so an unfilled entry can't ship a dead button.
 * mapEmbedUrl - optional, and the most accurate way to pin the map: Google Maps
 *               "Share -> Embed a map", then copy just the src="..." value out
 *               of the HTML it gives you. Takes priority over coords/name.
 * coords      - optional { lat, lng }; used to build an embed when there's no
 *               mapEmbedUrl. Falls back to searching by `name` if neither is set.
 * blurb       - the line under the address. Edit freely.
 *
 * The visible text and the schema stay at locality level, matching the
 * site-wide EntertainmentBusiness schema in HeroSection.js. Swap in a fuller
 * PostalAddress here if you'd rather publish the exact street address.
 */
const locations = {
  gurugram: {
    name: 'Mystery Mansion — Gurugram',
    path: '/gurugram',
    locality: 'Gurugram',
    region: 'Haryana',
    blurb: 'A private villa tucked away in Gurugram, within easy reach of Delhi NCR.',
    mapsUrl: 'https://www.google.com/maps/place/Mystery+Mansion:+Gurugram/data=!4m2!3m1!1s0x0:0x516145f378d3d780?sa=X&ved=1t:2428&ictx=111',
    mapEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3506.884935677847!2d77.08893537570484!3d28.483011690854468!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1900349d7c97%3A0x516145f378d3d780!2sMystery%20Mansion%3A%20Gurugram!5e0!3m2!1sen!2sin!4v1787588439799!5m2!1sen!2sin',
    coords: null,
  },
  greaterNoida: {
    name: 'Mystery Mansion — Greater Noida',
    path: '/greater-noida',
    locality: 'Greater Noida',
    region: 'Uttar Pradesh',
    blurb: 'A private farmhouse in Greater Noida, within easy reach of Delhi NCR.',
    mapsUrl: 'https://www.google.com/maps/place/Mystery+Mansion:+Greater+Noida/@28.4540904,77.5421121,17z/data=!3m1!4b1!4m6!3m5!1s0x390cc100520a35f7:0x54716fb11ee13722!8m2!3d28.4540858!4d77.546983!16s%2Fg%2F11z7tkbr83?entry=ttu&g_ep=EgoyMDI2MDgxOS4wIKXMDSoASAFQAw%3D%3D',
    mapEmbedUrl: '',
    coords: { lat: 28.4540858, lng: 77.546983 },
  },
};

export function mapEmbedSrc(location) {
  if (!location) return '';
  if (location.mapEmbedUrl) return location.mapEmbedUrl.split('"')[0].trim();

  const query = location.coords
    ? `${location.coords.lat},${location.coords.lng}`
    : location.name;
  if (!query) return '';

  const zoom = location.coords ? 15 : 13;
  return `https://maps.google.com/maps?q=${encodeURIComponent(query)}&z=${zoom}&output=embed`;
}

export const ORIGIN = 'https://www.mysterymansion.in';

export function locationSchema(location) {
  if (!location || !location.mapsUrl) return null;

  return {
    '@context': 'https://schema.org',
    '@type': 'EntertainmentBusiness',
    name: location.name,
    url: `${ORIGIN}${location.path}`,
    telephone: '+918279845322',
    address: {
      '@type': 'PostalAddress',
      addressLocality: location.locality,
      addressRegion: location.region,
      addressCountry: 'IN',
    },
    hasMap: location.mapsUrl,
  };
}

export default locations;
